import styled from '@emotion/styled';

export const PictureWrapper = styled.div`
  width: 60px;
  height: 60px;
  margin-right: 0.75rem;

  img {
    width: 100%;
    border: 1px solid #808080;
  }
`;
